export const getRoutes = (routables: Record<string, { path?: string }>) =>
	Object.entries(routables).reduce<Record<string, string>>((obj, [name, container]) => {
		if (container.path) {
			obj[name] = container.path
		}
		return obj
	}, {})
